(function () {
  angular
    .module('specsguardApp')
    .factory('BasicAreaLogic', BasicAreaLogic);

  BasicAreaLogic.$inject = ['Constants', 'filterModuleFactory'];

  function BasicAreaLogic (Constants, filterModuleFactory) {
    const logic: any = {};

    logic.filterInactive = (bAreas) => bAreas.filter((bArea) => bArea.active);

    logic.backupQualityLevel = (bArea) => {
      bArea.originalQualityLevel = bArea.qualityLevel;
    };

    logic.setAreaCount = (proj, bArea) => {
      bArea.hasArea = false;
      bArea.areaCount = 0;

      proj.buildings.forEach((building) => {

        building.clusters.forEach((cluster) => {
          cluster.areas.forEach((area) => {
            if (area.active === true && (area.basicArea === bArea._id || area.basicArea._id === bArea._id)) {
              bArea.hasArea = true;
              bArea.areaCount++;
              return bArea;
            }
          });
        });
      });
      return bArea;
    };

    logic.setMenuStructure = (menuStructure, basicArea) => {
      basicArea.menuStructure = menuStructure.map((menu) => {
        menu.modules = filterModuleFactory.filterByProjectLevel(menu.modules, null, basicArea._id);
        return menu;
      });
    };

    return logic;
  }
})();
